
(function($){
    
    $.TranslationButton = function(element, overlay_component) {
        this._overlay_component = overlay_component;
        this.element = element;
        this.style = element.style;
        this.location = ABDOUtil.getLocationFromDataset(this.element);
        this.flag = this.element.dataset.flag || null;
        this.init();
    };

    $.Component.create($.TranslationButton, {
        init: function() { 

            if (this.flag != null) {
                this.element.style.backgroundImage = "url('" + this.flag  + "')";
                this.element.style.backgroundRepeat = "no-repeat";
                this.element.style.backgroundSize = "contain";
                this.element.style.backgroundPosition = "center";
            }

            // prevent canvas propagation
            ABDOUtil.preventCanvasPropagation(this.element);

            if (this.location != null) {
                // get tip fields and build overlay object
                var overlay = { location: this.location };
                var tip_fields = new $.TipFields({
                    element: this.element,
                    overlay_data: overlay
                });
                overlay = Object.assign(overlay, tip_fields._overlay_data);
                overlay.element = this.element; 

                // console.log(overlay);
                // use overlay component to add overlay
                this._overlay_component._add_overlay(overlay); 
            }
        },
    }); 

    $.TranslationButtons = function() {
        this._component_name = 'translation_buttons';
        this._translation_buttons = [];
    };

    $.Component.create($.TranslationButtons, {
        _init_: function(options) {
            this._options = options || {};
            // connect to tips.ready event
            this.parent._on(this.parent._events.ready, this._parent_ready.bind(this));
        },
        _parent_ready: function() { 
            var jump_buttons  = document.querySelectorAll('.btn-show-translation'); 
            for (var i = 0; i < jump_buttons.length; i++) { 
                var element = jump_buttons[i];
                element.abdo_translation = new $.TranslationButton(element, this.parent);
            }
            // this._emit(this._events.ready);
        }
    }, $.Overlay);
})(ABDOMap);
